import { CommonModule, registerLocaleData } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { TranslateModule } from '@ngx-translate/core';

import { NgSelectModule } from '@ng-select/ng-select';

import en from '@angular/common/locales/en';
import pl from '@angular/common/locales/pl';
import ru from '@angular/common/locales/ru';
import uk from '@angular/common/locales/uk';
import { fullDateFormat } from '@constants';
import { NZ_DATE_CONFIG, NZ_I18N, pl_PL } from 'ng-zorro-antd/i18n';

import { MAT_DATE_FORMATS, MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { ChatsWrapperDesktopComponent } from '@shared/chats-wrapper/chats-wrapper-desktop/chats-wrapper-desktop.component';
import { ChatsWrapperMobileComponent } from '@shared/chats-wrapper/chats-wrapper-mobile/chats-wrapper-mobile.component';
import { CompanyLogoComponent } from '@shared/company-logo/company-logo.component';
import { CountrySelectComponent } from '@shared/country-select/country-select.component';
import { AutoFocusDirective } from '@shared/directives/auto-focus.directive';
import { SwipeDirective } from '@shared/directives/swipe.directive';
import { UserDetailsLinkDirective } from '@shared/directives/user-details-link.directive';
import { PaidTagComponent } from '@shared/paid-tags/paid-tag.component';
import { PhoneInputComponent } from '@shared/phone-input/phone-input.component';
import { CountriesVisitsFormLongResiComponent } from '@shared/personal-data-form/LONG_RESI/countries-visits-form-long-resi/countries-visits-form-long-resi.component';
import { FamilyMembersFormLongResiComponent } from '@shared/personal-data-form/LONG_RESI/family-members-form-long-resi/family-members-form-long-resi.component';
import { PreviousVisitsFormLongResiComponent } from '@shared/personal-data-form/LONG_RESI/previous-visits-form-long-resi/previous-visits-form-long-resi.component';
import { CountriesVisitsFormPermStayComponent } from '@shared/personal-data-form/PERM_STAY/countries-visits-form-perm-stay/countries-visits-form-perm-stay.component';
import { PermStayFormComponent } from '@shared/personal-data-form/PERM_STAY/perm-stay-form.component';
import { PermStayStep1Component } from '@shared/personal-data-form/PERM_STAY/perm-stay-step1/perm-stay-step1.component';
import { PermStayStep2Component } from '@shared/personal-data-form/PERM_STAY/perm-stay-step2/perm-stay-step2.component';
import { PermStayStep3Component } from '@shared/personal-data-form/PERM_STAY/perm-stay-step3/perm-stay-step3.component';
import { PermStayStep4Component } from '@shared/personal-data-form/PERM_STAY/perm-stay-step4/perm-stay-step4.component';
import { PreviousVisitsFormPermStayComponent } from '@shared/personal-data-form/PERM_STAY/previous-visits-form-perm-stay/previous-visits-form-perm-stay.component';
import { CountriesVisitsFormTempPremitComponent } from '@shared/personal-data-form/TEMP_PREMIT/countries-visits-form-temp-premit/countries-visits-form-temp-premit.component';
import { FamilyMembersFormTempPremitComponent } from '@shared/personal-data-form/TEMP_PREMIT/family-members-form-temp-premit/family-members-form-temp-premit.component';
import { PreviousVisitsFormTempPremitComponent } from '@shared/personal-data-form/TEMP_PREMIT/previous-visits-form-temp-premit/previous-visits-form-temp-premit.component';
import { ErrorsFormatingAndTranslatePipe } from '@shared/pipes/errors-formating-and-translate.pipe';
import { ConsultantFormattedTextPipe } from '@shared/pipes/consultant-formatted-text.pipe';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { ServiceLevelTagComponent } from '@shared/purchase-tags/service-level-tag.component';
import { SupportChatWindowDesktopDrawerComponent } from '@shared/support-chat-window/support-chat-window-desktop-drawer/support-chat-window-desktop-drawer.component';
import { SupportChatWindowMobileComponent } from '@shared/support-chat-window/support-chat-window-mobile/support-chat-window-mobile.component';
import { SupportChatDesktopComponent } from '@shared/support-chat/support-chat-desktop/support-chat-desktop.component';
import { SupportChatMobileComponent } from '@shared/support-chat/support-chat-mobile/support-chat-mobile.component';
import { MultipleDatesComponent } from 'ngx-multiple-dates';
import { AnnexFormComponent } from './annex/annex-form.component';
import { AnnexComponent } from './annex/annex.component';
import { InsuranceBannerComponent } from './banners/insurance-banner/insurance-banner.component';
import { TranslationsBannerComponent } from './banners/translations-banner/translations-banner.component';
import { BlockingModalComponent } from './blocking-modal/blocking-modal.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';
import { CustomTooltipDirective } from './custom-tooltip/custom-tooltip.directive';
import {
  MatDatepickerTouchUiDirective,
  MatDateRangePickerTouchUiDirective,
} from './directives/mat-datepicker-touch-ui.directive';
import { MatSelectMobileBackButtonDirective } from './directives/mat-select-mobile-back-button.directive';
import { MaskDisabledSyncDirective } from './directives/mask-disabled-sync.directive';
import { ensureMatSelectMinWidth } from './directives/mat-select-min-width.directive';
import { MatSelectPanelDirective } from './directives/mat-select-panel-directive';
import { NgSelectMobileBackButtonDirective } from './directives/ng-select-mobile-back-button.directive';
import { NzDatePickerMobileBackButtonDirective } from './directives/nz-date-picker-mobile-back-button.directive';
import { NzDrawerMobileBackButtonDirective } from './directives/nz-drawer-mobile-back-button.directive';
import { NzModalMobileBackButtonDirective } from './directives/nz-modal-mobile-back-button.directive';
import { NzSelectMobileBackButtonDirective } from './directives/nz-select-mobile-back-button.directive';
import { RequiredPermsDirective } from './directives/required-perms.directive';
import { SetTabIndexDirective } from './directives/set-tabindex.directive';
import { DiscussionModalComponent } from './discussion-modal/discussion-modal.component';
import { IntroModalComponent } from './intro-modal/intro-modal.component';
import { ModeChangedModalComponent } from './mode-changed-modal/mode-changed-modal.component';
import { MOSAnnexAddressComponent } from './mos-annex-address/mos-annex-address.component';
import { MyPartnerAccountDrawerComponent } from './my-partner-account-drawer/my-partner-account-drawer.component';
import { PayoutRequestModalComponent } from './my-partner-account-drawer/payout-request-modal/payout-request-modal.component';
import { NgZorroExportsModule } from './ngZorroExports.module';
import { LongResiFormComponent } from './personal-data-form/LONG_RESI/long-resi-form.component';
import { LongResiStep1Component } from './personal-data-form/LONG_RESI/long-resi-step1/long-resi-step1.component';
import { LongResiStep2Component } from './personal-data-form/LONG_RESI/long-resi-step2/long-resi-step2.component';
import { LongResiStep3Component } from './personal-data-form/LONG_RESI/long-resi-step3/long-resi-step3.component';
import { LongResiStep4Component } from './personal-data-form/LONG_RESI/long-resi-step4/long-resi-step4.component';
import { LongResiStep5Component } from './personal-data-form/LONG_RESI/long-resi-step5/long-resi-step5.component';
import { LongResiStep6Component } from './personal-data-form/LONG_RESI/long-resi-step6/long-resi-step6.component';
import { FamilyMembersFormPermStayComponent } from './personal-data-form/PERM_STAY/family-members-form-perm-stay/family-members-form-perm-stay.component';
import { PermStayStep5Component } from './personal-data-form/PERM_STAY/perm-stay-step5/perm-stay-step5.component';
import { PermStayStep6Component } from './personal-data-form/PERM_STAY/perm-stay-step6/perm-stay-step6.component';
import { PartialEntitlingDocumentComponent } from './personal-data-form/partial-entitling-document/partial-entitling-document.component';
import { PartialEntryDocumentComponent } from './personal-data-form/partial-entry-document/partial-entry-document.component';
import { PartialOriginCountryAddressComponent } from './personal-data-form/partial-origin-country-address/partial-origin-country-address.component';
import { PartialResidenceAddressComponent } from './personal-data-form/partial-residence-address/partial-residence-address.component';
import { PartialStayVisaComponent } from './personal-data-form/partial-stay-visa/partial-stay-visa.component';
import { PartialTravelDocumentComponent } from './personal-data-form/partial-travel-document/partial-travel-document.component';
import { TempPremitFormComponent } from './personal-data-form/TEMP_PREMIT/temp-premit-form.component';
import { TempPremitStep1Component } from './personal-data-form/TEMP_PREMIT/temp-premit-step1/temp-premit-step1.component';
import { TempPremitStep2Component } from './personal-data-form/TEMP_PREMIT/temp-premit-step2/temp-premit-step2.component';
import { TempPremitStep3Component } from './personal-data-form/TEMP_PREMIT/temp-premit-step3/temp-premit-step3.component';
import { TempPremitStep4Component } from './personal-data-form/TEMP_PREMIT/temp-premit-step4/temp-premit-step4.component';
import { TempPremitStep5Component } from './personal-data-form/TEMP_PREMIT/temp-premit-step5/temp-premit-step5.component';
import { CukrFormComponent } from './personal-data-form/CUKR/cukr-form.component';
import { CukrStep1Component } from './personal-data-form/CUKR/cukr-step1/cukr-step1.component';
import { CukrStep2Component } from './personal-data-form/CUKR/cukr-step2/cukr-step2.component';
import { CukrStep3Component } from './personal-data-form/CUKR/cukr-step3/cukr-step3.component';
import { NationalitySelectComponent } from './personal-data-form/nationality-select/nationality-select.component';
import { PersonalDataFormComponent } from './personal-data-form/personal-data-form.component';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { FilterListPipe } from './pipes/filter-list.pipe';
import { LinebreaksPipe } from './pipes/linebreaks.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SafeUrlPipe } from '@shared/pipes/safe-url.pipe';
import { PurchaseProductCardComponent } from './purchase-product-card/purchase-product-card.component';
import { UpsellCardComponent } from './upsell-card/upsell-card.component';
import { CtaGenericComponent } from './cta-generic/cta-generic.component';
import { RefreshTokenModalComponent } from './refresh-token-modal/refresh-token-modal.component';
import { SwitchOptionPillsComponent } from './switch-option-pills/switch-option-pills.component';
import { TimePickerModalComponent } from './time-picker-modal/time-picker-modal.component';
import { UserProcessStatusComponent } from './user-process-status/user-process-status.component';
import { UserProcessModePillComponent } from './user-process-mode-pill/user-process-mode-pill.component';
import { UtilsButtonsComponent } from './utils-buttons/utils-buttons.component';
import { CrButtonComponent } from '@shared/_cr-components/cr-button/cr-button.component';
import { MatListModule } from '@angular/material/list';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MfaActionVerificationModalComponent } from './mfa-action-verification-modal/mfa-action-verification-modal.component';
import { MfaActionVerificationModalService } from './mfa-action-verification-modal/mfa-action-verification-modal.service';
import { CrHeaderComponent } from '@shared/_cr-components/cr-header/cr-header.component';
import { CompanyPluralPipe } from '@shared/pipes/plural-company.pipe';
import { CrBackButtonComponent } from '@shared/_cr-components/cr-back-button/cr-back-button.component';
import { CrEmployeeRoleTagComponent } from './_cr-components/cr-employee-role-tag/cr-employee-role-tag.component';
import { CrUserTagSelectorComponent } from './_cr-components/cr-user-tag-selector/cr-user-tag-selector.component';
import { CrAvatarComponent } from './_cr-components/cr-avatar/cr-avatar.component';
import { CrFormFieldTooltipComponent } from './_cr-components/cr-form-field-tooltip/cr-form-field-tooltip.component';
import { RequiredSupportingCompanyDirective } from './directives/required-supporting.company';
import { StripHtmlPipe } from '@shared/pipes/strip-html.pipe';
import { TruncateBeforePipe } from '@shared/pipes/truncate-before.pipe';
import { ExtractParenthesisPipe } from '@shared/pipes/extract-parentesis.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MfaInfoModalComponent } from './mfa-info-modal/mfa-info-modal.component';
import { MfaInfoModalService } from './mfa-info-modal/mfa-info-modal.service';

registerLocaleData(pl);
registerLocaleData(en);
registerLocaleData(uk);
registerLocaleData(ru);

const commonModules = [
  CommonModule,
  OverlayModule,
  NgSelectModule,
  FormsModule,
  ReactiveFormsModule,
  FullCalendarModule,
];

const materialModules = [
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatMenuModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatSortModule,
  MatSelectModule,
  MatPaginatorModule,
  MatStepperModule,
  MatRadioModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatMomentDateModule,
  MatTabsModule,
  MatDialogModule,
  MatExpansionModule,
  MatBadgeModule,
  MatChipsModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatCardModule,
  MatSlideToggleModule,
  MatListModule,
  MatTimepickerModule,
];

const components = [
  CustomTooltipComponent,
  FamilyMembersFormTempPremitComponent,
  FamilyMembersFormLongResiComponent,
  FamilyMembersFormPermStayComponent,
  CountrySelectComponent,
  CountriesVisitsFormTempPremitComponent,
  CountriesVisitsFormLongResiComponent,
  PreviousVisitsFormTempPremitComponent,
  PreviousVisitsFormLongResiComponent,
  PersonalDataFormComponent,
  TempPremitFormComponent,
  TempPremitStep1Component,
  TempPremitStep2Component,
  TempPremitStep3Component,
  TempPremitStep4Component,
  TempPremitStep5Component,
  CukrFormComponent,
  CukrStep1Component,
  CukrStep2Component,
  CukrStep3Component,
  LongResiFormComponent,
  LongResiStep1Component,
  LongResiStep2Component,
  LongResiStep3Component,
  LongResiStep4Component,
  LongResiStep5Component,
  PermStayFormComponent,
  PermStayStep1Component,
  PermStayStep2Component,
  PermStayStep3Component,
  PermStayStep4Component,
  PermStayStep5Component,
  PermStayStep6Component,
  PartialStayVisaComponent,
  PartialEntitlingDocumentComponent,
  PartialEntryDocumentComponent,
  PartialOriginCountryAddressComponent,
  PartialResidenceAddressComponent,
  PartialTravelDocumentComponent,
  CountriesVisitsFormPermStayComponent,
  PreviousVisitsFormPermStayComponent,
  LongResiStep6Component,
  UtilsButtonsComponent,
  SwitchOptionPillsComponent,
  AnnexComponent,
  AnnexFormComponent,
  MOSAnnexAddressComponent,
  ChatsWrapperDesktopComponent,
  ChatsWrapperMobileComponent,
  SupportChatDesktopComponent,
  SupportChatMobileComponent,
  SupportChatWindowMobileComponent,
  SupportChatWindowDesktopDrawerComponent,
  PurchaseProductCardComponent,
  UpsellCardComponent,
  CtaGenericComponent,
  NationalitySelectComponent,
  CompanyLogoComponent,
  UserProcessStatusComponent,
  UserProcessModePillComponent,
  ServiceLevelTagComponent,
  PaidTagComponent,
  InsuranceBannerComponent,
  TranslationsBannerComponent,
  MyPartnerAccountDrawerComponent,
  PayoutRequestModalComponent,
  PhoneInputComponent,
];

const cr = [
  CrButtonComponent,
  CrHeaderComponent,
  CrBackButtonComponent,
  CrEmployeeRoleTagComponent,
  CrUserTagSelectorComponent,
  CrAvatarComponent,
  CrFormFieldTooltipComponent,
];

const modals = [
  DiscussionModalComponent,
  ConfirmationModalComponent,
  IntroModalComponent,
  RefreshTokenModalComponent,
  TimePickerModalComponent,
  ModeChangedModalComponent,
  BlockingModalComponent,
  MfaActionVerificationModalComponent,
  MfaInfoModalComponent,
];

const pipes = [
  TruncatePipe,
  TruncateBeforePipe,
  ConsultantFormattedTextPipe,
  SanitizeHtmlPipe,
  SafeHtmlPipe,
  SafeUrlPipe,
  LinebreaksPipe,
  OrderByPipe,
  FilterListPipe,
  ErrorsFormatingAndTranslatePipe,
  CustomDatePipe,
  CompanyPluralPipe,
  StripHtmlPipe,
  ExtractParenthesisPipe,
];

const directives = [
  CustomTooltipDirective,
  MatSelectPanelDirective,
  SetTabIndexDirective,
  AutoFocusDirective,
  SwipeDirective,
  UserDetailsLinkDirective,
  RequiredPermsDirective,
  RequiredSupportingCompanyDirective,
  MatDatepickerTouchUiDirective,
  MatDateRangePickerTouchUiDirective,
  MatSelectMobileBackButtonDirective,
  NgSelectMobileBackButtonDirective,
  NzSelectMobileBackButtonDirective,
  NzDatePickerMobileBackButtonDirective,
  NzModalMobileBackButtonDirective,
  NzDrawerMobileBackButtonDirective,
  MaskDisabledSyncDirective,
];

ensureMatSelectMinWidth();

export const MY_FORMATS = {
  parse: {
    dateInput: fullDateFormat,
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: fullDateFormat,
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 200,
    exitDuration: 0,
  },
};

@NgModule({
  declarations: [...components, ...cr, ...directives, ...modals, ...pipes],
  imports: [
    ...commonModules,
    ...materialModules,
    NgZorroExportsModule,
    RouterModule,
    MultipleDatesComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule,
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: NZ_I18N, useValue: pl_PL },
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
    MfaActionVerificationModalService,
    MfaInfoModalService,
    provideNgxMask(),
  ],
  exports: [
    ...commonModules,
    ...materialModules,
    NgZorroExportsModule,
    TranslateModule,
    MultipleDatesComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ...components,
    ...cr,
    ...directives,
    ...pipes,
  ],
})
export class SharedModule {}
